import { TextMaterialCategory } from '@entities/Blog/types/types'

import { useTextMaterialCategoriesQuery } from '@shared/generated'


export default function useTextMaterialCategories () {
  const { data, loading, error } = useTextMaterialCategoriesQuery()

  const textMaterialCategories = (data?.textMaterialCategories?.filter(Boolean) || []).map(category => ({
    id: category?.id || '',
    title: category?.title || undefined,
    slug: category?.slug || undefined,
  })) as TextMaterialCategory[]

  return {
    textMaterialCategories,
    data: textMaterialCategories,
    loading,
    error,
  }
}
